import { Link } from "react-router-dom";
import NewsletterForm from "@/components/NewsletterForm";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-hussar-gold/10 bg-hussar-bg2/40">
      <div className="px-6 sm:px-10 lg:px-16 max-w-[1600px] mx-auto py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="metadata-label mb-4">Weekly Intelligence</div>
            <h3 className="font-serif text-2xl sm:text-3xl text-hussar-ink leading-snug mb-6">
              One disciplined research note, weekly. Nothing else.
            </h3>
            <NewsletterForm source="footer" />
          </div>
          <div className="lg:col-span-3 lg:col-start-7">
            <div className="metadata-label mb-6">Navigate</div>
            <div className="flex flex-col gap-3">
              <Link to="/" data-testid="footer-link-treasury" className="text-hussar-slate hover:text-hussar-gold text-sm transition-colors">Hussar Treasury</Link>
              <Link to="/lab" data-testid="footer-link-lab" className="text-hussar-slate hover:text-hussar-gold text-sm transition-colors">Hussar Lab Methodology</Link>
              <Link to="/intelligence" data-testid="footer-link-intelligence" className="text-hussar-slate hover:text-hussar-gold text-sm transition-colors">Weekly Intelligence Archive</Link>
              <Link to="/governance" data-testid="footer-link-governance" className="text-hussar-slate hover:text-hussar-gold text-sm transition-colors">Governance & Security</Link>
              <Link to="/request-access" data-testid="footer-link-request-access" className="text-hussar-slate hover:text-hussar-gold text-sm transition-colors">Request Early Access</Link>
              <a href="/api/rss.xml" data-testid="footer-link-rss" className="text-hussar-slate hover:text-hussar-gold text-sm transition-colors">RSS — Weekly Intelligence</a>
            </div>
          </div>
          <div className="lg:col-span-3">
            <div className="metadata-label mb-6">The Record</div>
            <p className="text-hussar-muted text-xs leading-relaxed">
              hussartreasury.com is the public research record of Hussar Treasury. The operational treasury system is
              private and is never exposed here. Only sanitized, owner-approved research crosses the boundary.
            </p>
            <p className="text-hussar-muted text-xs leading-relaxed mt-4">
              Nothing on this site constitutes investment advice, an offer, or a solicitation.
            </p>
          </div>
        </div>
        <div className="gold-hairline mt-16 mb-8" />
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-hussar-muted">
            © {new Date().getFullYear()} Hussar Treasury — Every Dollar Has a Job
          </div>
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-hussar-muted">
            Public Record · Zero Silent Rewrites
          </div>
        </div>
      </div>
    </footer>
  );
}
